module.exports = __webpack_public_path__ + "img/modules.af31a056.svg";